import React, {useEffect, useMemo, useRef, useState} from "react";
import { ReactComponent as ForgeLogo } from "../images/logos/forge-logo.svg";
import { ReactComponent as AppsIcon } from "../images/icons/apps.svg";
import { ReactComponent as AdminIcon } from "../images/icons/admin.svg";
import { ReactComponent as LoginIcon } from "../images/icons/user.svg";
import { useNavigate } from "react-router-dom";
import LoginPopup from "./elements/navigation/LoginPopup.js";
import ProfileIcon from "./elements/navigation/ProfileIcon.js";
import UserPopup from "./elements/navigation/UserPopup.js";
import {UserUtils} from "../utils/UserUtils.js";

export default function NavigationMenu()
{
    const navigate = useNavigate();
    const user = UserUtils.getCurrentUser();

    const [loginPopupOpen, setLoginPopupOpen] = useState(false);
    const [userPopupOpen, setUserPopupOpen] = useState(false);

    const menuItems = [{id: "apps", icon: AppsIcon, link: "/"}];

    if(user != null && user.roles != null && user.roles.some(role => role.permsList?.includes("admin")))
    {
        menuItems.push({id: "admin", icon: AdminIcon, link: "/admin"});
    }

    const originalUrl = window.location.href;
    let selectedId = "apps"

    try { selectedId = originalUrl.substring(originalUrl.lastIndexOf("/") + 1); }
    catch(ignored) {}

    if(selectedId === "" || selectedId === "/") selectedId = "apps";

    const selectedIndex = menuItems.findIndex(item => item.id === selectedId)
    const previousIndex = selectedIndex > 0 ? selectedIndex - 1 : -1;
    const nextIndex = selectedIndex < menuItems.length - 1 ? selectedIndex + 1 : -1;

    const loginPopupRef = useRef(null);
    const userPopupRef = useRef(null);

    const handleDocumentClick = (event) =>
    {
        if (loginPopupRef.current && !loginPopupRef.current.contains(event.target))
        { setLoginPopupOpen(false); }
        if (userPopupRef.current && !userPopupRef.current.contains(event.target))
        { setUserPopupOpen(false); }
    };

    useEffect(() =>
    {
        document.addEventListener('click', handleDocumentClick);
        return () => { document.removeEventListener('click', handleDocumentClick); };
    }, []);

    return (
        <div id="menu-area">
            <div id="top-menu-area" className={previousIndex === -1 ? "previous-item" : ""}>
                <ForgeLogo id="menu-logo"/>
            </div>
            <div id="menu-list-container">
                <ul id="menu-list">
                    {
                        menuItems.map((item, idx) =>
                        {
                            return (
                                <li
                                    key={item.id}
                                    id={item.id}
                                    className={`menu-item ${idx === selectedIndex ? 'selected' : ''} ${idx === previousIndex ? 'previous-item' : ''} ${idx === nextIndex ? 'next-item' : ''}`}
                                    onClick={() => navigate(item.link)}
                                >
                                    <div className="menu-item-background"></div>
                                    <div className="menu-item-content">
                                        <item.icon className="menu-item-icon"/>
                                    </div>
                                </li>
                            );
                        }
                    )}
                </ul>
            </div>
            <div id="bottom-menu-area" className={nextIndex === -1 ? "next-item" : ""}>
                {
                    user == null && (
                        <>
                            <LoginPopup ref={loginPopupRef} shown={loginPopupOpen}/>
                            <div
                                key="login"
                                id="login"
                                className="login"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setLoginPopupOpen(true);
                                }}
                            >
                                <LoginIcon className="menu-item-icon"/>
                            </div>
                        </>
                    )
                }
                {
                    user != null && (
                        <>
                            <UserPopup ref={userPopupRef} shown={userPopupOpen}/>
                            <ProfileIcon onClick={(e) =>
                            {
                                e.stopPropagation();
                                setUserPopupOpen(true);
                            }}/>
                        </>
                    )
                }
            </div>
        </div>
    );
}